<template>
    <div class="p-3">
        <el-card header="Vídeos promocionais">
            <el-row class="py-2">
                <h5 class="v-col-6 v-col-md-9 me-3">Pesquisar</h5>
                <div class="v-col-6 v-col-md-3">
                    <el-radio-group v-model="searchType">
                        <el-radio value="string" border>por título</el-radio>
                        <el-radio value="number" border>Pelo codigo</el-radio>
                    </el-radio-group>
                </div>
            </el-row>
            <ElRow class="pb-5" v-if="searchType == 'string'">
                <ElInput type="search" name="q" style="flex: 1" v-model="q" class="mx-1" placeholder="Procurar produtos" />
                <ElButton :loading="loading" @click="() => getVideos(q)">
                    <ElIcon>
                        <Search />
                    </ElIcon>
                </ElButton>
            </ElRow>
            <ElRow class="pb-5" v-else>
                <ElInput type="number" name="cod" v-model="cod" style="flex: 1" class="mx-1" placeholder="Digite o codigo do produto" />
                <ElButton :disabled="cod ? false:true" :loading="loading" @click="() => getVideo(cod)">
                    <ElIcon>
                        <Search />
                    </ElIcon>
                </ElButton>
            </ElRow>
            <PaginatedTable :loading="loading" :height="450" :showRows="10" :cols="[
                {label: 'Cod', prop: 'id'},
                {label: 'title', prop: 'title'},
            ]" :data="data" @change="(p) => getVideos(q, p)" :pages="pages">
                <el-table-column label="Cadastrado por" class-name="auto" :min-width="200">
                    <template #default="data">
                        <span class="p-2">
                            {{ data.row.user?.name }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="Acções" class-name="auto" :min-width="150">
                    <template #default="data">
                        <span class="p-2">
                            <el-button type="primary" icon="Edit" title="Editar Info" @click="() => openVideo(data.row.id)"></el-button>
                        </span>
                        <span class="p-2">
                            <el-button @click="() => deleteVideo({title: data.row.title, id: data.row.id})" type="danger" icon="DeleteFilled" title="Eliminar"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PaginatedTable>
        </el-card>

        <ModalComponent v-if="video" @close="() => {video = null}" cardclass="col-12 col-md-6 col-lg-5 col-x-lg-4" header="Editar informações do vídeo">
            <VideoView :video="video" @update="() => getVideos(q)" />
        </ModalComponent>
    </div>
</template>

<script lang="ts" setup>
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElButton, ElIcon, ElInput, ElMessage, ElMessageBox, ElRow } from 'element-plus';
    import { useStore } from 'vuex';
    import { Video } from '@/services/types';
    import PaginatedTable from '@/components/PaginatedTable.vue';
    import ModalComponent from '@/components/modals/ModalComponent.vue';
    import VideoView from '@/components/modals/views/VideoView.vue';

    const loading = ref<boolean>(true)
    const data = ref<Video[]>([])
    const q = ref<string>('')
    const pages = ref<number>(1)
    const searchType = ref<'string' | 'number'>('string')
    const cod = ref<number>()
    const video = ref<Video | null | undefined | false | 0>(null)

    const getVideos = async (q = '', page = 1) => {
        loading.value = true
        const params = new URLSearchParams()
        params.append('q', q)
        params.append('page', String(page))
        console.log('admin/videos?' + params.toString())
        const res = await Api.get('admin/videos?' + params.toString())
        console.log(res.data.videos)
        if (res.status == 200) {
            pages.value = res.data.videos.last_page
            data.value = res.data.videos.data
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }
    
    const getVideo = async (id: number | undefined) => {
        if (!id || id <= 0) {
            getVideos()
        } else {
            loading.value = true
            pages.value = 1
            q.value = ''
            const res = await Api.get('admin/videos/' + id)
            if (res.status == 200) {
                data.value = [res.data.video]
            } else {
                ElMessage.error('Não foi encontrado nenhum video com este código')
                data.value = []
            }
            loading.value = false
        }
    }

    onBeforeMount(async () => {
        await getVideos()
    })

    const store = useStore()
    store.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 7) {
            // new product
            await getVideos()
        }
    })

    const openVideo = async (id: number) => {
        loading.value = true
        const res = await Api.get('admin/videos/' + id)
        if (res.status == 200) {
            video.value = res.data.video
        } else {
            ElMessage.error('Este video não foi encontrado')
            video.value = null
        }
        loading.value = false
    }

    const deleteVideo = async ({title, id}: {title: string, id: number}) => {
        const yes = confirm(`Deseja realmente eliminar o vídeo ${title} permanentemente?`)
        if (yes) {
            loading.value = true
            const res = await Api.delete(`admin/videos/${id}`)
            if (res.status != 200) {
                ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
                loading.value = false
            } else {
                ElMessage.success({message: title + ' Eliminado'})
                getVideos()
            }
        }
    }
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
